// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-mantine-color-scheme=dark] .j93vY\\+x0imW9IiOmIRBMSA\\=\\={color:var(--sma-color-white)}", "",{"version":3,"sources":["webpack://./resources/react/Components/ui/logo-type.module.css"],"names":[],"mappings":"AAAA,8DACI,4BACJ","sourcesContent":["[data-mantine-color-scheme=\"dark\"] .label {\n    color: var(--sma-color-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "j93vY+x0imW9IiOmIRBMSA=="
};
export default ___CSS_LOADER_EXPORT___;
